import * as React from 'react';
import { Link } from 'react-router';
import { __, __r } from 'react-i18n';
import { FlexColCenter } from '../../Defaults/Flexbox/Flexbox';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { IconType, SvgIcon } from '../General/SvgIcon';
import { IconImg } from '../../Defaults/Icon/IconImg';
import * as uploadSrc from '../../../../assets/zemplin/upload.svg';
import { TextP } from '../../Defaults/Text';

interface Props {
  theme: any;
}

function EmptyCart({ theme }: Props) {
  return (
    <Wrapper>
      <SvgIcon
        width={48}
        height={48}
        viewBox="0 0 48 48"
        icon={IconType.emptyCart}
        alt={__('Ikonka preškrtnutého košíka')}
        fill={theme.colors.stockCountUnavailable}
        marginLeft={0}
      />
      <Title>{__('Váš nákupný košík je prázdny')}</Title>
      <SmallText>
        {__('Pridajte produkty do košíka, alebo použite import objednávky.')}
      </SmallText>
      <ImportOrderButton
        to={__r('routes:import-objednavky', '/import-objednavky')}
      >
        <IconImg
          src={uploadSrc.toString()}
          width={24}
          height={24}
          alt="upload-icon"
          cursor="pointer"
        />{' '}
        <ImportOrderTitle>{__('Import objednávky')}</ImportOrderTitle>
      </ImportOrderButton>
    </Wrapper>
  );
}

const Wrapper = styled(FlexColCenter)`
  width: 100%;
  margin: 0 auto;
  padding: ${rem(24)} 0;

  ${({ theme }) => theme.mediab.m580`
   padding: ${rem(32)} 0 0;
  `}
`;

const Title = styled.h2`
  margin: ${rem(32)} 0;
  font-size: ${rem(30)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(38)};
  font-weight: 400;

  ${({ theme }) => theme.mediab.m580`
    font-size: ${rem(24)};
    line-height: ${rem(32)};
    text-align: center;
  `}
`;

const SmallText = styled(TextP)`
  font-weight: 400;
  font-family: ${({ theme }) => theme.font.secondaryLight};
  line-height: ${rem(22)};
  font-size: ${rem(14)};
  margin-bottom: ${rem(32)};
  text-align: center;
`;

const ImportOrderButton = styled(Link)`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.white};
  font-size: ${rem(14)};
  padding: ${rem(8)};
  height: ${rem(48)};
  display: flex;
  align-items: center;
  line-height: ${rem(22)};
  text-decoration: none;
  border: ${({ theme }) => theme.borders.primary};

  max-width: ${rem(229)};
  width: 100%;
  display: flex;
  justify-content: center;
  max-height: ${rem(62)};
  transition: filter 0.2s ease;

  &:hover {
    filter: brightness(90%);
  }

  ${({ theme }) => theme.mediab.m580`
      max-width: ${rem(288)};
  `}
`;

const ImportOrderTitle = styled.span`
  margin-left: ${rem(16)};
  display: flex;
  align-items: flex-end;
`;

const WithTheme: any = withTheme(EmptyCart);
export { WithTheme as EmptyCart };
